import { hmt_statistic } from '@/utils/index'
import { QIDIAN_EXPAND, TODAY_CALL_CUSTOMERS, config } from '../constant'
import dayjs from "dayjs";

let basickey = [
	{ urlKey: 'vcc_code', infoKey: 'vccCode', infoVal: '' },
	{ urlKey: 'user_id', infoKey: 'userId', infoVal: '' },
	{ urlKey: 'user_num', infoKey: 'userNum', infoVal: '' },
	{ urlKey: 'user_name', infoKey: 'userName', infoVal: '' }
]

const replacePlaceholder = (url) => {
	basickey.map(({ urlKey, infoVal }) => {
		let reg = new RegExp('{{' + urlKey + '}}', 'ig')
		let flag = reg.test(url)
		if (flag) {
			url = url.replace(reg, infoVal)
		}
	})
	return url
}

const getPathByPath = (rawData,fullPath=[])=>{
  let strPath = [],title = ''
  let data = rawData
  fullPath.map((path,index)=>{
    strPath.push(data[path].name)
    data = data[path].children || {}
  })

  const [last,prev1,prev2] = strPath.reverse()
  if(strPath.length > 3){
    title =`${last}（${prev1}/${prev2}）`
  }else{
    title =`${last}(${prev1})`
  }
  console.log(strPath,'strPath')
  return { strPath, title }
}

export const switchLanguage = (state, lang) => {
	state.lang = lang
}

export const setRawMenuData = (state, data)=>{
  state.rawMenuData = data || {}
}

export const addTab = (state, obj) => {
	if (!obj.key) {
		obj.key = obj.title
	}

	obj.url = replacePlaceholder(obj.url)

	let findIndex = state.tabData.findIndex(tab => tab.key == obj.key)

	// 存储 activeTabKey
	state.activeTabKey = obj.key

	if (findIndex == -1) {
    let hasSameTitle = state.tabData.findIndex(tab=>tab.name === obj.name)
    if(hasSameTitle != -1){
      if (Array.isArray(obj.fullPath) && obj.fullPath.length >= 2) {
        let pathInfo = getPathByPath(state.rawMenuData,obj.fullPath)
        obj.name = pathInfo.title
      }
    }
		state.tabData.push({ ...obj, iframeId: `iframe_${obj.key}` })
	} else {
    let exsitTab = state.tabData[findIndex]
		const iframeId = exsitTab.iframeId

		// 已打开，并配置了不刷新
		if (exsitTab.hasOwnProperty('refresh') && !exsitTab.refresh) {
			return false
		}
		// url相同，刷新
		if (exsitTab.url == obj.url) {
			document.getElementById(iframeId).src = document.getElementById(iframeId).src
		} else {
			state.tabData.splice(findIndex, 1, { ...obj, iframeId: `iframe_${obj.key}` })
		}
	}

	// 埋点统计
	hmt_statistic(obj.url, obj.title || obj.name || '')
}

export const delTab = (state, obj) => {
	let key = obj.key || state.activeTabKey;
	let tabData = state.tabData;
	for (let i in tabData) {
		if (tabData[i].key == key) {
			if (key == state.activeTabKey) {
				// 本条active
				if (tabData.length > 1) {
					// 顺序排第一，显示后一个
					if (i == 0) {
						state.activeTabKey = tabData[1].key
					} else {
						// 顺序不是第一，显示前一个
						state.activeTabKey = tabData[i - 1].key
					}
				} else {
					state.activeTabKey = '';
				}
				// 删除本条
				tabData.splice(i, 1)
				break
			} else {
				//非active，直接删除本条
				tabData.splice(i, 1)
				break
			}
		}
	}
	if (state.tabData.length == 0) {
		state.activeTabKey = config.HOME_PAGE_KEY
	}
}

export const delAllTab = (state) => {
	state.tabData = []
	state.activeTabKey = config.HOME_PAGE_KEY
}

export const delOtherTab = (state, obj) => {
	let key = obj.key;
	let idx = state.tabData.findIndex(tab => tab.key == key)
	state.tabData.splice(idx + 1)
	// 做一个延迟调用，同时执行可能会导致当前页签刷新
	setTimeout(() => {
		state.tabData.splice(0, state.tabData.length - 1)
		if (state.tabData.length == 0) {
			state.activeTabKey = config.HOME_PAGE_KEY
		}
	})
}

export const changeActiveTabKey = (state, val) => {
	state.activeTabKey = val
}

export const changeDrawerInfo = (state, obj) => {
	if (state.drawerInfo.drawerSrc != obj.drawerSrc) {
		state.drawerInfo = obj;
	} else {
		state.drawerInfo = {
			drawerShow: false,
			drawerSrc: "",
			drawerWidth: "0"
		}
	}
}

export const changeUserInfo = (state, obj) => {
	state.userInfo = obj;
	basickey.map(item => {
		item.infoVal = obj[item.infoKey]
	})
}

export const changeDialogInfo = (state, obj) => {
	const { width = 580, height = 460, ...others } = obj
	state.dialogInfo = { ...others, width, height };
}

export const changeFloatBarMenu = (state, obj) => {
	state.floatBarMenu = obj;
}
export const setMenuList = (state, array) => {
	state.menuList = array
}
export const setOtherSystemConfig = (state, obj) => {
	state.otherSystemConfig = obj
}
export const setCallRecords = (state, array) => {
	state.callRecords = array
}
export const setQidianExpand = (state, val) => {
  if(val) {
    localStorage.setItem(QIDIAN_EXPAND, '1')
  } else {
    localStorage.removeItem(QIDIAN_EXPAND)
  }
	state.qidianExpand = val
}
export const setQidianExpandCalling = (state, val) => {
  if(!val) {
    if(!localStorage.getItem(QIDIAN_EXPAND)) {
      state.qidianExpand = val
    }
  } else {
    state.qidianExpand = val
  }
}
export const setTodayCallCustomers = (state, obj) => {
  if(!obj.cle_phone) return
  const curDate = dayjs().format('YYYY-MM-DD')
  const todayData = state.todayCallCustomers[curDate]
  let ret = {}
  if(todayData) {
    ret = {[curDate]: {...todayData}}
  } else {
    ret = {[curDate]: {}}
  }
  ret[curDate][obj.cle_phone] = obj
	state.todayCallCustomers = ret
  localStorage.setItem(TODAY_CALL_CUSTOMERS, JSON.stringify(ret))
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js